import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=791299ae&scoped=true&"
var script = {}
import style0 from "./preview.vue?vue&type=style&index=0&id=791299ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791299ae",
  null
  
)

export default component.exports